import React from 'react'
import styled from 'styled-components'
import Gallery from './Gallery'
import FooterInfo from './FooterInfo'
import FooterMenu from './FooterMenu'

const FooterWrapper = styled.footer`
  padding: 6rem 2rem 2rem 2rem;
  background-color: var(--black);
  color: var(--yellow);

  @media (max-width: 576px) {
    padding-bottom: 1rem;
  }

  .footer-wrapper {
    max-width: 1300px;
    margin: 0 auto 0 auto;
  }

  .copyright {
    padding: 2rem 0 2rem 0;
    color: rgba(255, 255, 255, 0.7);
    font-family: 'Open Sans', sans-serif;
    font-size: 1.5rem;
    text-align: center;
  }

  .name {
    margin-bottom: 0.6rem;
  }
`

const Footer = () => (
  <FooterWrapper>
    <div className="footer-wrapper">
      <Gallery />
      <FooterInfo />
      <FooterMenu />
      <div className="copyright">
        <div className="name">
          &copy; {new Date().getFullYear()} База отдыха "Золотая звезда"
        </div>
        <div>
          Номер реестровой записи{' '}
          <a
            href="https://tourism.fsa.gov.ru/ru/resorts/hotels/4b40d5a9-c609-11ef-92da-e3904a1708a4/about-resort"
            target="_blank">
            С192024006546
          </a>
        </div>
      </div>
    </div>
  </FooterWrapper>
)

export default Footer
